import clsx from 'clsx';
import { useState, useRef, useEffect } from 'react';
import { addParameterToUrl, getUrlParameter } from '@portal-internet/core';
import { useData } from 'hooks/useData';
import __isEmpty from 'lodash/isEmpty';
import styles from './graellacatchup.module.scss';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import Icona from 'components/corporatiu/Icona/Icona';
import Enllac from 'components/corporatiu/Enllac';
import CodiEspectador from 'components/corporatiu/CodiEspectador';
import { getHora, getIsoShort } from 'utils/comu/dateHelper';
import { dataResources } from 'utils/constants';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Boto from 'components/corporatiu/Boto';

const { basePath } = dataResources;

function MesInfo({ item, isRadio }) {
    const [isDesplegat, setIsDesplegat] = useState(false);
    const refDesplegable = useRef(null);
    const refMesInfoWrapper = useRef(null);

    const entradeta = isRadio
        ? (item.descripcio || '').trimEnd().replace(/\n/g, '<br>')
        : (item.entradeta || '').trimEnd().replace(/\n/g, '<br>');

    const stylesMesInfo = clsx({
        [styles.mesinfo]: true,
        [styles.desplegat]: isDesplegat
    });

    const stylesBoto = clsx({
        [styles.btn_mesinfo]: true,
        [styles.desplegat]: isDesplegat
    });

    const _desplegable = () => {
        if (isDesplegat === true) {
            refDesplegable.current.style.height = '';
        } else {
            refDesplegable.current.style.height = refMesInfoWrapper.current.scrollHeight + 'px';
        }
        setIsDesplegat(!isDesplegat);
    };

    return (
        <>
            <Boto
                tag='button'
                text={isDesplegat ? 'tanca' : 'info'}
                className={stylesBoto}
                estil='grisquadrat'
                mida='small'
                icona={isDesplegat ? 'tanca' : 'mes'}
                isIconaBlanc={!isDesplegat}
                isIconaDreta={false}
                onClick={_desplegable}
            />
            <div className={stylesMesInfo} ref={refDesplegable}>
                <div className={styles.mesInfoWrapper} ref={refMesInfoWrapper}>
                    <CodiEspectador
                        codiEdat={item.codis_etics?.[0].id}
                        codiAD={item.audio_desc}
                        codiSub={item.subtitulacions}
                        codiVO={item.versio_original}
                    />
                    <div
                        className={styles.entradeta}
                        dangerouslySetInnerHTML={{
                            __html: entradeta ? entradeta : ''
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
}

export default function GraellaCatchup(props) {
    const { items, urlGraella, routerQuery, mostraImatges = true, estil, numDiesFuturs = 9 } = props;

    const { data: itemsDinamic, getDades, isLoading } = useData();
    const [itemsDinamics, setItemsDinamics] = useState(items);
    const canal = routerQuery?.id || props.canal;
    const dataString = getUrlParameter(urlGraella, 'data_emissio');
    const [diaSeleccionat, setDiaSeleccionat] = useState(dataString);
    const [isLoadingCanal, setIsLoadingCanal] = useState(false);
    const navigationPrev = useRef(null);
    const navigationNext = useRef(null);
    const isRadio = canal === 'CATRADIO' || canal === 'CATCULTURA' || canal === 'CATMUSICA' || canal === 'CATINFORMA';

    const stylesGraellaCatchup = clsx({
        [styles.graellaCatchup]: true,
        [styles.isloading]: isLoading || isLoadingCanal,
        [styles[estil]]: !__isEmpty(estil)
    });

    const stylesDies = clsx({
        [styles.dies]: true,
        [styles.menysDiesFuturs]: numDiesFuturs <= 3
    });

    const renderDies = (canal) => {
        return (
            <Swiper
                modules={[Navigation, FreeMode]}
                className={stylesDies}
                slidesPerView={'auto'}
                freeMode={true}
                tag='div'
                wrapperTag='ul'
                navigation={{ prevEl: navigationPrev.current, nextEl: navigationNext.current }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = navigationPrev.current;
                    swiper.params.navigation.nextEl = navigationNext.current;
                }}
            >
                <SwiperSlide tag='li' className={styles.dia}>
                    <h2 className={styles.diaText}>
                        <button
                            onClick={() => actualitzaDades(canal, dataString)}
                            className={diaSeleccionat === dataString ? styles.selected : ''}
                        >
                            Avui
                        </button>
                    </h2>
                </SwiperSlide>
                {Array.from({ length: numDiesFuturs }, (_, i) => {
                    const date = new Date();
                    date.setDate(date.getDate() + i + 1);
                    const day = date.getDate();
                    const weekdays = ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'];
                    const weekday = weekdays[date.getDay()];
                    const isTomorrow = i === 0;
                    const weekdayText = isTomorrow ? 'DEMÀ' : `${weekday}. ${day}`;
                    const diaKey = `${dataString}+${i + 1}`;
                    return (
                        <SwiperSlide key={i} tag='li' className={styles.dia}>
                            <h2 className={styles.diaText}>
                                <button
                                    onClick={() => actualitzaDades(canal, diaKey)}
                                    className={diaSeleccionat === diaKey ? styles.selected : ''}
                                >
                                    {weekdayText}
                                </button>
                            </h2>
                        </SwiperSlide>
                    );
                })}
                <div className={styles.fletxes}>
                    <button ref={navigationPrev} className={styles.anterior}>
                        <Icona
                            icona='fletxa_simple_esquerra'
                            isBlanc={true}
                            alt='Anterior'
                            mida={24}
                            inline={true}
                            tabIndex={0}
                        />
                    </button>
                    <button ref={navigationNext} className={styles.seguent}>
                        <Icona icona='fletxa_simple_dreta' isBlanc={true} alt='Següent' mida={24} inline={true} tabIndex={0} />
                    </button>
                </div>
            </Swiper>
        );
    };

    const renderCanals = (canal, isRadio) => {
        const canals = isRadio
            ? [
                  {
                      href: '/catradio/programacio/catalunya-radio/',
                      id: 'CATRADIO',
                      alt: 'Catalunya Ràdio',
                      logo: 'cr.svg',
                      width: 27,
                      height: 25
                  },
                  {
                      href: '/catradio/programacio/3catinfo-radio/',
                      id: 'CAD_324',
                      alt: '3CatInfo',
                      logo: '3catinfo.svg',
                      width: 90,
                      height: 18
                  },
                  {
                      href: '/catradio/programacio/catalunya-musica/',
                      id: 'CATMUSICA',
                      alt: 'Catalunya Música',
                      logo: 'cm_quadrat.svg',
                      width: 25,
                      height: 25
                  },
                  { href: '/catradio/programacio/icat/', id: 'CATCULTURA', alt: 'iCat', logo: 'ic.svg', width: 25, height: 25 }
              ]
            : [
                  { href: '/tv3/programacio/canal-tv3/', id: 'CAD_TV3', alt: 'TV3', logo: 'tv3.svg', width: 30, height: 25 },
                  {
                      href: '/tv3/programacio/canal-3catinfo-tv/',
                      id: 'CAD_324',
                      alt: '3CatInfo',
                      logo: '3catinfo.svg',
                      width: 90,
                      height: 18
                  },
                  { href: '/tv3/programacio/canal-sx3/', id: 'CAD_SX3', alt: 'SX3', logo: 'sx3.svg', width: 50, height: 25 },
                  { href: '/tv3/programacio/canal-33/', id: 'CAD_C33', alt: '33', logo: '33.svg', width: 32, height: 25 },
                  {
                      href: '/tv3/programacio/canal-esport3/',
                      id: 'CAD_ES3',
                      alt: 'Esport3',
                      logo: 'esport3.svg',
                      width: 42,
                      height: 25
                  },
                  {
                      href: '/tv3/programacio/canal-tv3cat/',
                      id: 'CAD_TVI',
                      alt: 'TV3Cat',
                      logo: 'tv3cat.svg',
                      width: 50,
                      height: 25
                  }
              ];

        return (
            <ul className={styles.canals}>
                {canals.map((item, index) => (
                    <li key={index} className={styles.canal}>
                        <Enllac
                            onClick={() => setIsLoadingCanal(true)}
                            className={clsx(styles.linkCanal, {
                                [styles.active]: item.id === canal
                            })}
                            href={item.href}
                        >
                            <Imatge
                                width={item.width}
                                height={item.height}
                                alt={item.alt}
                                src={`${basePath}/_resources/logos/${item.logo}?v=JIT_ENV_RESOURCES_VERSION`}
                            />
                        </Enllac>
                    </li>
                ))}
            </ul>
        );
    };

    const actualitzaDades = (canal, dia) => {
        setDiaSeleccionat(dia);
        let currentUrl = addParameterToUrl(urlGraella, 'canal', canal);
        currentUrl = addParameterToUrl(currentUrl, 'data_emissio', dia);

        getDades(currentUrl);
    };

    useEffect(() => {
        setItemsDinamics(itemsDinamic);
    }, [itemsDinamic]);

    useEffect(() => {
        setItemsDinamics(items);
        setDiaSeleccionat(dataString);
        setTimeout(() => setIsLoadingCanal(false), 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    const route = canal === 'CAD_SX3' ? 'web_sx3_programa' : 'web_3cat_programa';

    return (
        <div className={stylesGraellaCatchup}>
            {!__isEmpty(canal) && canal !== 'CAD_BND' && renderCanals(canal, isRadio)}
            {renderDies(canal)}
            <div className={styles.loader}>
                <div className={styles.spinner}></div>
            </div>
            {!__isEmpty(itemsDinamics) && (
                <ul className={styles.programes}>
                    {itemsDinamics.map((item, index) => {
                        const programa = item.programes?.[0] || item.programa?.[0];

                        return (
                            <li key={`${index}-${diaSeleccionat}-${canal}`} className={styles.programa}>
                                <time className={styles.hora} dateTime={getIsoShort(item.data_emissio)}>
                                    {getHora(item.data_emissio)}
                                </time>
                                <div className={styles.infoWrapper}>
                                    {mostraImatges && (
                                        <div className={styles.imatgeWrapper}>
                                            <span>
                                                {item.imatges ? (
                                                    <Imatge
                                                        imatges={item.imatges}
                                                        className={styles.imatge}
                                                        tipus='web_graella'
                                                        mostrarRecurs={false}
                                                        layout='fill'
                                                        objectFit='contain'
                                                        priority={false}
                                                    />
                                                ) : (
                                                    item.url_imatge_destacat && (
                                                        <Imatge
                                                            src={item.url_imatge_destacat}
                                                            className={styles.imatge}
                                                            tipus='web_graella'
                                                            mostrarRecurs={false}
                                                            layout='fill'
                                                            objectFit='contain'
                                                            priority={false}
                                                        />
                                                    )
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    <div className={styles.desc}>
                                        <p className={styles.titol}>
                                            {!__isEmpty(programa?.nom_bonic) ? (
                                                <Enllac
                                                    className={styles.linkPrograma}
                                                    route={{ type: route, slug: programa?.nom_bonic }}
                                                    title={item.titol}
                                                >
                                                    {item.titol}
                                                </Enllac>
                                            ) : (
                                                <>{item.titol}</>
                                            )}
                                        </p>

                                        <p className={styles.capitol}>{item.capitols?.[0]?.desc}</p>
                                    </div>
                                </div>
                                <MesInfo item={item} isRadio={isRadio} />
                            </li>
                        );
                    })}
                </ul>
            )}
            {__isEmpty(itemsDinamics) && <p className={styles.noData}>Dades no disponibles</p>}
        </div>
    );
}
